import React, { PropsWithChildren } from 'react';

import PropTypes from 'prop-types';
import styledC from 'styled-components';

import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

import { TABLE_SIZES } from '../consts';
import getTableTheme from '../helpers/getTableTheme';
import { Themeable } from '../types';

type Cell = {
  size?: number | string;
  isResizing?: boolean;
};

export type TableCellProps = StylableComponent<HTMLDivElement> &
  Themeable &
  Cell;

const StyledTD = styledC.td<Cell & { cellPadding: number }>`
  width: ${({ size }) => (typeof size === 'number' ? `${size}px` : size)};
  flex: ${({ size }) => size + ' 0 auto'};
  display: flex;
  align-items: center;
  height: 100%;
  border-bottom: 1px solid ${theme.tokens.colors.border.subtler.value};
  padding: 0 ${({ cellPadding }) => cellPadding}px;
  border-right: 1px solid
    ${({ isResizing }) =>
      isResizing
        ? theme.tokens.colors.border.selected.subtle.value
        : 'transparent'};
  background-color: ${theme.tokens.colors.background.primary.value};
  & a {
    text-decoration: none;
    color: inherit;
    width: ${({ size }) => (typeof size === 'number' ? `${size}px` : size)};
    flex: ${({ size }) => size + ' 0 auto'};
    display: flex;
    align-items: center;
    height: 100%;
  }
`;

const TableCell = ({
  size,
  isResizing,
  children,
  tableSize,
  ...props
}: PropsWithChildren<TableCellProps>) => {
  const tableSizeTheme = getTableTheme(tableSize);
  return (
    <StyledTD
      role="cell"
      size={size}
      $isResizing={isResizing}
      tabIndex={-1}
      cellPadding={tableSizeTheme.cellPadding}
      {...props}
    >
      {children}
    </StyledTD>
  );
};

TableCell.propTypes = {
  tableSize: PropTypes.oneOf(Object.values(TABLE_SIZES)),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isResizing: PropTypes.bool,
  children: PropTypes.any,
  style: stylePropType,
};

export default TableCell;
